import React, { useState, forwardRef, useImperativeHandle } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline"; // Import Hero Icons
import { motion } from "framer-motion"; 
import ChatInput from './ChatInput';


const Chatbot = forwardRef((props, ref) => {
  const { title } = props;
  const [isVisible, setIsVisible] = useState(false);

  // 🟡 Expose `toggle` method via `useImperativeHandle`
  useImperativeHandle(ref, () => ({
    toggle: () => setIsVisible((prev) => !prev),
  }));

  if (!isVisible) return null; // ✅ Ensuring hooks are always called before conditionals

  return (
    <motion.div
    initial={{ opacity: 0, x: 50, y: 50, scale: 0.95 }} // 🟡 Starts from bottom-right corner
    animate={{ opacity: 1, x: 0, y: 0, scale: 1 }} // 🟢 Moves to normal position
    exit={{ opacity: 0, x: 50, y: 50, scale: 0.95 }} // 🔴 Exits back to bottom-right
    transition={{ duration: 0.3, ease: "easeOut" }} // 🎭 Smooth motion
        className="fixed z-10 bottom-4 left-4 right-4 w-auto mx-auto bg-white drop-shadow-lg rounded-xl p-5 lg:w-full lg:max-w-lg lg:left-auto"
    >
      <div className="flex justify-between items-center mb-4">
        <h4 className="text-lg font-semibold">{title}</h4>
        <button onClick={() => setIsVisible(false)}>
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
      
      <ChatInput userType={props.userType} />
    </motion.div>
  );
});

export default Chatbot;
